import React, { useEffect, useState } from 'react';
import { update, type OperatorSelectorProps } from 'react-querybuilder';

import { formatOptions } from '../helper';

import VirtualizeAutocomplete from '../../VirtualizeAutocomplete/VirtualizedAutocomplete';

const CustomOperatorSelector: React.FC<OperatorSelectorProps> = ({
  path,
  value,
  schema,
  options,
  disabled,
  handleOnChange,
}) => {
  const { getQuery, dispatchQuery } = schema;

  const [valueSelected, setValueSelected] = useState<any>();

  useEffect(() => {
    const formattedOptions =
      options && options.length > 0 ? formatOptions(options) : undefined;
    const foundValue = formattedOptions
      ? formattedOptions.find((el) => el.name == value)
      : null;
    setValueSelected(foundValue);
  }, [value, options]);

  return (
    <div className="custom-operator-selector-container">
      <VirtualizeAutocomplete
        width={400}
        label="Operator"
        disabled={disabled}
        value={valueSelected}
        includeGroupLabel={true}
        handleChange={(event: any, value: any) => {
          handleOnChange(value ? value.name : '');
          const query = getQuery();
          if (query) {
            dispatchQuery(update(query, 'value', '', path));
          }
        }}
        groupedOptions={
          options && options.length > 0 ? formatOptions(options) : []
        }
      />
    </div>
  );
};

export default CustomOperatorSelector;
